<template lang="pug">
#location
  .main_title.text-center 服務據點
  img.search_img(src="/IMAGE/Location/Location_Image.png")
  .search_bar.d-flex.justify-content-center
  .auto_search.text-center.i_mt_4(@click="findLocation")
    svg-icon.i_mr_4(
      iconClass="chevron-circle-down-solid",
      className="chevron-circle-down-solid",
      data-toggle="tooltip",
      data-placement="left"
    )
    | 自動尋找最近服務據點(行動裝置定位適用)
  .neibouring_location
    .container
      transition(name="page", mode="out-in")
        map-item.i_mt_10.i_mb_20(
          v-if="showRecentLocation",
          :location="recentLocation"
        )

    nav.i_mt_6.i_m_auto
      .tabs.flex_h.justify-content-center
        .tab_.flex-grow-1(
          v-for="(areaDetail, index) in area.AreaList",
          @click="changeTab(index, areaDetail)"
        )
          tab(
            :key="index",
            :selected="index == selectedIndex",
            :tab="areaDetail.AreaName"
          )
  .container.i_mb_10
    map-item(
      v-for="(location, index) in tempLocationList",
      :key="index",
      :location="location"
    )
  custom-footer
  // Google Tag Manager (noscript)
  noscript
    iframe(src="https://www.googletagmanager.com/ns.html?id=GTM-MK9D2SM3"
height="0" width="0" style="display:none;visibility:hidden")
  // End Google Tag Manager (noscript)
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import Tab from "@/components/location/Tab";
import MapItem from "@/components/location/Map";
import { getArea } from "@/json/location";
import { getLocation } from "@/json/location";

export default {
  name: "Location",
  components: {
    "custom-footer": CustomFooter,
    tab: Tab,
    "map-item": MapItem,
  },
  // head: {
  //   script: [
  //     {
  //       inner: `
  //         <!-- Google Tag Manager -->
  //         (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  //         new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  //         j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  //         'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  //         })(window,document,'script','dataLayer','GTM-MK9D2SM3');
  //         <!-- End Google Tag Manager -->
  //       `,
  //     },
  //   ],
  // },
  data() {
    return {
      area: {},
      location: {},
      tempLocationList: [],
      selectedIndex: 0,
      recentLocation: {},
      showRecentLocation: false,
    };
  },
  watch: {},
  created() {
    this.getArea();
  },
  mounted() {},
  methods: {
    changeTab(index, areaDetail) {
      this.selectedIndex = index;
      this.tempLocationList = [];
      for (let index in this.location.LocationList) {
        let location = this.location.LocationList[index];
        if (areaDetail.AreaID == location.AreaID) {
          this.tempLocationList.push(location);
        }
      }
    },
    getArea() {
      getArea().then((response) => {
        this.area = response.data;
        this.getLocation();
      });
    },
    getLocation() {
      getLocation().then((response) => {
        this.location = response.data;
        if (this.area.AreaList.length > 0) {
          this.changeTab(0, this.area.AreaList[0]);
        }
      });
    },
    // 使用者不提供權限，或是發生其它錯誤
    error() {
      alert("無法取得你的位置");
    },
    // 使用者允許抓目前位置，回傳經緯度
    success(position) {
      let distance = null;
      let tempLocation = null;
      for (let x in this.location.LocationList) {
        let temp = this.location.LocationList[x];
        let tempLat = temp.Locationlatlng.split(",")[1];
        let tempLng = temp.Locationlatlng.split(",")[0];
        let tempDistance = this.getDistance(
          position.coords.latitude,
          position.coords.longitude,
          tempLat,
          tempLng
        );
        if (distance == null) {
          distance = tempDistance;
          tempLocation = temp;
        } else {
          if (tempDistance < distance) {
            distance = tempDistance;
            tempLocation = temp;
          }
        }
      }
      this.recentLocation = tempLocation;
      this.showRecentLocation = true;
    },
    findLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.success, this.error);
      } else {
        alert("Sorry, 你的裝置不支援地理位置功能。");
      }
    },
    getDistance(lat1, lng1, lat2, lng2) {
      var radLat1 = (lat1 * Math.PI) / 180.0;
      var radLat2 = (lat2 * Math.PI) / 180.0;
      var a = radLat1 - radLat2;
      var b = (lng1 * Math.PI) / 180.0 - (lng2 * Math.PI) / 180.0;
      var s =
        2 *
        Math.asin(
          Math.sqrt(
            Math.pow(Math.sin(a / 2), 2) +
              Math.cos(radLat1) *
                Math.cos(radLat2) *
                Math.pow(Math.sin(b / 2), 2)
          )
        );
      s = s * 6378.137; // EARTH_RADIUS;
      s = Math.round(s * 10000) / 10000;
      return s;
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/search_bar";
@import "@/assets/style/location/location";
</style>
